import { companyInfo } from '../data/siteData';

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="pt-20">
      {/* Header */}
      <section className="py-16 md:py-24 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-slate-900 font-outfit">
            Privacy Policy
          </h1>
          <p className="text-slate-600 font-manrope mt-4">
            Last updated: January 2026
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="prose prose-slate max-w-none font-manrope">
            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Introduction
            </h2>
            <p className="text-slate-600 mb-8">
              {companyInfo.fullName} ("we," "our," or "us") respects your privacy and is committed 
              to protecting your personal data. This privacy policy explains how we collect, use, 
              and safeguard your information when you visit our website or use our services.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Information We Collect
            </h2>
            <p className="text-slate-600 mb-4">We may collect the following types of information:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-8 space-y-2">
              <li>Personal identification information (name, email address, phone number)</li>
              <li>Inquiry details and preferences related to our properties</li>
              <li>Technical data (IP address, browser type, device information)</li>
              <li>Usage data (how you interact with our website)</li>
            </ul>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              How We Use Your Information
            </h2>
            <p className="text-slate-600 mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-8 space-y-2">
              <li>Respond to your inquiries and provide customer support</li>
              <li>Send you information about our projects and services</li>
              <li>Improve our website and user experience</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Data Security
            </h2>
            <p className="text-slate-600 mb-8">
              We implement appropriate security measures to protect your personal information 
              against unauthorized access, alteration, disclosure, or destruction. However, 
              no method of transmission over the internet is 100% secure.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Third-Party Disclosure
            </h2>
            <p className="text-slate-600 mb-8">
              We do not sell, trade, or otherwise transfer your personal information to 
              third parties without your consent, except as required by law or to protect 
              our rights.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Your Rights
            </h2>
            <p className="text-slate-600 mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 text-slate-600 mb-8 space-y-2">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
            </ul>

            <h2 className="text-2xl font-semibold text-slate-900 font-outfit mb-4">
              Contact Us
            </h2>
            <p className="text-slate-600 mb-4">
              If you have any questions about this privacy policy, please contact us at:
            </p>
            <p className="text-slate-600">
              <strong>Email:</strong> {companyInfo.email}<br />
              <strong>Phone:</strong> {companyInfo.phone}<br />
              <strong>Address:</strong> {companyInfo.address}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
